<template>
    <div>
        <h3 class="mt-3">Resources / Capacity</h3>

        <form novalidate @change="eventActivateUpdateFlag('ResourcesCapacity')">
            <div class="row mt-5">
                <div class="scheduleTypeHolder col-sm-10 d-flex align-items-center mb-3">
                    <button
                        type="button"
                        class="btn tertiary"
                        :class="{'selected': selectedAvailabilityType == availabilityType.value}"
                        :disabled="disableAvailabilityType(availabilityType.value)"
                        v-for="availabilityType in availabilityTypes" :key="availabilityType.value" @click="setAvailabiltyType(availabilityType)">{{availabilityType.label}}</button>
                </div>

                <div class="col-sm-10" v-if="getSelectedEvent.availabilityType == AvailabilityTypes.LIMITED_BY_RESOURCES">
                    <div class="d-flex align-items-start">
                        <span>Share availability with other products</span>
                    </div>

                    <div class="mt-2 mb-3 fs-small dark">
                        <div class="d-inline-flex align-items-center bold mb-2">
                            <radio  class="d-flex" v-model="getSelectedEvent.shareType" :value="ProductShareTypes.NOSHARE" :disabled="(getSelectedEvent.shareType === ProductShareTypes.NOSHARE) || (disableShareType(ProductShareTypes.NOSHARE))"/>
                            <span class="radio-label ml-1">NO</span>
                        </div>
                        <div class="d-inline-flex align-items-center bold mb-2">
                            <radio v-model="getSelectedEvent.shareType" :value="ProductShareTypes.SHARE" :disabled="(getSelectedEvent.isPrivateEvent == true || getSelectedEvent.shareType === ProductShareTypes.SHARE) || disableShareType(ProductShareTypes.SHARE)" />
                            <span class="radio-label ml-1">
                                YES. Products that use the same resource at the same time will share availability. You can set max.seats per product.
                                <small v-if="getSelectedEvent.isPrivateEvent == true" class="brand">(Private events cannot share availability)</small>
                            </span>
                        </div>
                        <div class="d-inline-flex align-items-center bold mb-2">
                            <radio v-model="getSelectedEvent.shareType" :value="ProductShareTypes.VIRTUALROSTER" :disabled="(getSelectedEvent.shareType === ProductShareTypes.VIRTUALROSTER) || disableShareType(ProductShareTypes.VIRTUALROSTER)" />
                            <span class="radio-label ml-1">
                                Virtual Roster - If a product is using the same resource at the same time, the first activity to be booked will turn the other activities unavailable to book.
                            </span>
                        </div>
                    </div>
                </div>

                <div v-if="getSelectedEvent.availabilityType == AvailabilityTypes.FIXED_LIMIT" class="col-sm-10 d-flex align-items-center mb-3">
                    <label class="full">
                        Total Capacity
                        <input type="text" class="bg-lighter mt-1" size="2" v-model="totalCapacity" v-numInt :disabled="true">
                    </label>
                </div>

                <div class="col-sm-10">
                    <div class="row">
                        <div class="col-sm-6">
                            <label class="full">
                                Resources for this event
                            </label>
                        </div>
                        <div class="col-sm-4">
                            <label v-if="getSelectedEvent.availabilityType == AvailabilityTypes.LIMITED_BY_RESOURCES">Capacity limit</label>
                        </div>
                    </div>

                    <div class="row align-items-center mt-2" v-for="(resource, index) in getSelectedEvent.eventResources" :key="resource && resource.id || index">
                        <div class="col-sm-6">
                            <v-select class="mr-2"
                                :options="resourcesToSelect"
                                v-model="getSelectedEvent.eventResources[index]"
                                @input="resouceSelected(getSelectedEvent.eventResources[index])"
                                label="name">
                            </v-select>
                        </div>

                        <div class="col-sm-4 text-right d-flex align-items-center">
                            <span v-if="getSelectedEvent.availabilityType == AvailabilityTypes.LIMITED_BY_RESOURCES">
                                <input 
                                    type="text" 
                                    :class="{'border-color-6':resource.invalid, 'mr-1': true}" 
                                    v-numInt 
                                    style="width: 55px;" 
                                    v-model="resource.maxSeats" 
                                    :max="fetchCapacity(resource)" 
                                    @input="maxSeatsChanged(resource)"> / {{resource.availability}}
                            </span>

                            <span class="color-6 ml-2 fs-smaller" v-if="resource.invalid">Invalid</span>
                        </div>

                        <div class="col-sm-2">
                            <i class="ico ico-delete largest dark pointer" @click="removeResource(index)"></i>
                        </div>

                        <div class="col-sm-12" v-if="resource.isAvailable !== undefined && !resource.isAvailable">
                            <span class="color-6 fs-small font-weight-600">Warning! This resource is already in use at this time</span>
                        </div>
                    </div>

                    <div v-if="resourcesToSelect.length < 1" class="dark fs-small bold">
                        All resoureces are in use
                    </div>

                    <div class="mt-5">
                        <span @click="addResource" :class="{'opacity-50': resourcesToSelect.length < 1}">
                            <span class="ico-add color-1 mr-1 rounded-circle border-color-1 p-1 pointer"></span>
                            <label class="pointer">Add New</label>
                        </span>
                    </div>

                    <div class="color-6 my-2" v-if="validations.getSelectedEvent.resources.$invalid">
                        If availbility is "Limited by resources" then you need at least one resource.
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    import extendedVSelect from '@/extends/vue-select'
    import { ProductShareTypes, AvailabilityTypes } from '@/enums/productAvailabilityTypes';

    export default {
        data() {
            return {
                resourcesAvailabilty: [],
                tweakedResources: [],
                ProductShareTypes,
                AvailabilityTypes
            }
        },
        props: {
            validations: {
                type: Object
            }
        },
        mixins: [],
        watch: { 
            'getSelectedEvent.availabilityType': {
                immediate: true, 
                handler(newVal) {
                    if (!this.getSelectedEvent) return;

                    const curMaxLotation = this.getSelectedEvent.maximumLotation

                    if (newVal !== AvailabilityTypes.FIXED_LIMIT) { 
                        if (curMaxLotation === 0 || curMaxLotation === -1) {
                            this.$set(this.getSelectedEvent, 'maximumLotation', -1);
                        }

                        if (newVal === AvailabilityTypes.LIMITED_BY_RESOURCES) {
                            this.normalizeResourceMaxSeats();
                        }
                    } else {
                        // Fixed Limited (0)
                        if (curMaxLotation === -1) {
                            this.$set(this.getSelectedEvent, 'maximumLotation', 0);
                        }
                    }
                } 
            },
                isResourcesValid: {
                    immediate: true,
                    handler(newVal) {
                        this.setHasResourceErrors(!newVal);
                    }
                }
        },
        created() {
            this.initResources();
            this.resourcesAvailabilty = this.getAvailableResources();
        },
        computed: {
            ...mapGetters([
                'getSelectedEvent',
                'getResources',
                'isCreatingSingleEvent',
                'account',
                'getAvailabilityTypes'
            ]),
            ...mapGetters('eventFormState', [
                'isResourcesValid'
            ]),
            availabilityTypes() {
                return this.getAvailabilityTypes;
            },
            totalCapacity: {
                get() {
                    const event = this.getSelectedEvent || {};
                    const maxLotation = event.maximumLotation;

                    return (maxLotation === -1 || maxLotation == null) ? 0 : maxLotation;
                },
                set(newVal) {
                    const parsed = parseInt(newVal, 10);
                    const newTotalCapacity = isNaN(parsed) ? 0 : parsed;

                    this.$set(this.getSelectedEvent, 'maximumLotation', newTotalCapacity);
                }
            },
            availableResources () {
                return this.getResources;
            },
            resourcesToSelect () {
                return this.availableResources.filter(availableResource => {
                    let foundUsedResource = this.getSelectedEvent.eventResources.find(usedResource => {return usedResource.id == availableResource.id});
                    
                    return (!foundUsedResource)? true : false;
                });
            },
            selectedAvailabilityType() {
                return this.getSelectedEvent.availabilityType;
            }
            ,
        },
        methods:{
            ...mapActions([
                'initResources'
            ]),
            ...mapActions('eventFormState', [
                'setHasResourceErrors'
            ]),
            normalizeResourceMaxSeats() {
                const list = this.getSelectedEvent && this.getSelectedEvent.eventResources || [];

                list.forEach((res, i) => {
                    if (!res) return;
                    const needsInit = res.maxSeats == null || res.maxSeats < 0;
                    const avail = typeof res.availability === 'number' ? res.availability : 0;
                    
                    if (needsInit) {
                        this.$set(this.getSelectedEvent.eventResources[i], 'maxSeats', avail);
                    }
                });
            },
            fetchCapacity(item) {
                return item ? item.availability : '-';
            },
            maxSeatsChanged(resource) {
                const isInvalid = resource.maxSeats > this.fetchCapacity(resource);
                this.$set(resource, 'invalid', isInvalid);
            },
            addResource() {
                if (this.resourcesToSelect.length < 1) {
                    return false;
                }

                // Adding a updateflag to ResourcesCapacity on editEvent | This function is in mixin.js
                this.eventActivateUpdateFlag('ResourcesCapacity');

                if (this.getResources && this.getResources.length > 0) {
                    this.getSelectedEvent.eventResources.push(this.resourcesToSelect[0]);
                } else {
                    this.getSelectedEvent.eventResources.push({
                        "name": " "
                    });
                }
            },
            removeResource(index) {
                if (!this.getSelectedEvent || !this.getSelectedEvent.eventResources) {
                    return false;
                }

                const deleteResource = () => {
                    // Adding a updateflag to ResourcesCapacity on editEvent | This function is in mixin.js
                    this.eventActivateUpdateFlag('ResourcesCapacity');
                    this.getSelectedEvent.eventResources.splice(index, 1);
                };

                if (this.getSelectedEvent.passengerSettings && this.getSelectedEvent.availabilityType === AvailabilityTypes.LIMITED_BY_RESOURCES) {
                    this.$dialog
                        .confirm(`
                            <div class="fs-larg font-weight-600 mb-4">Remove resource?</div>
                            <div>You have availability depending on resources, are you sure you want to continue?</div>
                        `)
                        .then(() => deleteResource())
                        .catch(() => {});
                } else {
                    deleteResource();
                }
            },
            async getAvailableResources() {
                try {
                    let response = await axios.get('/api/calendar/GetResourcesAvailabilityStatus', { 
                        params: {
                            supplierId: this.account.supplierId,
                            dateFrom: this.getSelectedEvent.start,
                            dateTo: this.getSelectedEvent.end
                        }
                    });

                    if (response && response.status === 200) {
                        let resourcesAvailabilty = response.data;
                        this.resourcesAvailabilty = resourcesAvailabilty;

                        // This populate tweakedResources with a array of objects that is the apiResource with the added key "isAvailable"
                        this.tweakedResources = [];
                        for (let avalResource of resourcesAvailabilty) {
                            let tempObj = avalResource.resource;
                            tempObj.isAvailable = avalResource.isAvailable;
                            this.tweakedResources.push(tempObj);
                        }

                        return response.data;
                    }
                } catch (error) {}
            },
            setAvailabiltyType(availabilityType) {
                // Adding a updateflag to ResourcesCapacity on editEvent | This function is in mixin.js
                this.eventActivateUpdateFlag('ResourcesCapacity');
                this.$set(this.getSelectedEvent, 'availabilityType', availabilityType.value);

                if (availabilityType.value == AvailabilityTypes.LIMITED_BY_RESOURCES && this.getSelectedEvent.eventResources.length == 0) {
                    this.addResource();
                    
                    if (this.getSelectedEvent.shareType == null) {
                        this.getSelectedEvent.shareType = ProductShareTypes.NOSHARE;
                    }
                }
            },
            disableAvailabilityType(availability) {
                return this.getSelectedEvent.availabilityType !== availability;
            },
            disableShareType(shareType) {
                if (this.getSelectedEvent.shareType !== ProductShareTypes.VIRTUALROSTER && shareType === ProductShareTypes.VIRTUALROSTER)
                {
                    return true;
                }

                return this.getSelectedEvent.shareType === ProductShareTypes.VIRTUALROSTER
            },
            resouceSelected(selectedResource) {
                // Adding a updateflag to ResourcesCapacity on editEvent | This function is in mixin.js
                this.eventActivateUpdateFlag('ResourcesCapacity');
                if (selectedResource.maxSeats < 0) {
                    selectedResource.maxSeats = selectedResource.availability;
                    // Adding a updateflag to ResourcesCapacity on editEvent | This function is in mixin.js
                    this.eventActivateUpdateFlag('ResourcesCapacity');
                }
            }
        },
        components: {
            vSelect: extendedVSelect
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_variables.scss';
    
    .scheduleTypeHolder {
        button {
            line-height: normal;
            height: 80px;
            width: 160px;
            margin-right: 0.5rem;

            &.selected {
                border-color: $color-1;
                border-width: 2px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// areaResources.vue?7089dd1f